import Homepage from '../../common/Homepage.vue';

export default [
  {
    path: '/',
    name: 'Homepage',
    redirect: '/Homepage',
  },
  {
    path: '/Homepage',
    component: Homepage,
  },
];
